import { LegalEntityEnum } from '@onrunning/backstage-models';

export const orderOverviewId = 'overview_id';

export const stockClearanceConstants = {
  customerPoNumberDisabledLegalEntities: [LegalEntityEnum.ON_CA, LegalEntityEnum.ON_US] as LegalEntityEnum[],
};
